import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
// TODO: Restore MsalProvider when PingID auth is implemented
// import { MsalProvider } from '@azure/msal-react';
// import { PublicClientApplication } from '@azure/msal-browser';
// import { msalConfig } from '../../authentication/AuthConfig';
// export const publicClientApplication = new PublicClientApplication(msalConfig);

const Root = ({ store }) => (
    <Router>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>
  );

Root.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  store: PropTypes.object.isRequired,
};

export default Root;
